import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router'

import { BotoesGridVersaoRender } from './botoesGridVersao.component'
import { ExibirMenuService } from '../../shared/exibir-menu.service'
import { DadosAcessoService } from '../../../dadosAcesso.service'
import { VersaoService } from './versao.service'
import { AcessoApiService } from '../../../acessoApi.service'
import { NotificationsService } from 'angular2-notifications';
import {AgGridModule} from 'ag-grid-angular/main';

declare var $: any

@Component({
  selector: 'app-versao',
  templateUrl: './versao.component.html',
  styleUrls: ['./versao.component.css']
})
export class VersaoComponent implements OnInit {
  public colDef: any
  private frameworkComponents;
  private columnDefs;
  private rowData;
  private context;
  public rodar;


  public COD_LOJA : number
  public ID_SIS: number
  public modal: string = ""
  public VERSAO: string
  public QTDE_PDV: number
  public TIPO_INST: string
  public OBS_INST: string

  public sistemas: any
  public versoes: any

  public arrayVersao: any

  

  constructor(private exibirItens: ExibirMenuService, private dadosAcesso: DadosAcessoService, private router: Router, private acessoAPI: AcessoApiService, private notificacao: NotificationsService, public acessarVersao :VersaoService) { 
    if(sessionStorage.getItem('cod_loja') === null){

      this.router.navigate(["/"])
    }
    
    this.exibirItens.setItensVisiveis(true);

    this.acessoAPI.CarregarVersaoLoja().subscribe(res =>{
      this.arrayVersao = res
  
      this.rowData = this.arrayVersao
  
    }, error =>{
    })


  this.acessoAPI.getListaSistemas().subscribe(res =>{
    
    this.sistemas = res
  })

  this.acessoAPI.getListaVersoes().subscribe(res =>{
    
    this.versoes = res

  })

    this.columnDefs = [
      {headerName: 'Cód Loja', field: 'COD_LOJA' },
      {headerName: 'Sistema', field: 'NOME_SIS' },
      {headerName: 'Versão', field: 'VERSAO'},
      {headerName: 'Qtde. PDV', field: 'QTDE_PDV'},
      {headerName: 'Tipo Inst', field: 'TIPO_INST'},
      {headerName: '', field: 'ID_INST', cellRenderer:"botoesGridVersaoRender", colId: 'ID_INST', width: 100}
  ];
  
  this.context = { componentParent: this };
  
  this.frameworkComponents = {
    botoesGridVersaoRender: BotoesGridVersaoRender
  }

  }

  ngOnInit() {
  }

  changeSis(sistema){
    
    this.ID_SIS = parseInt(sistema.value);
 }

 changeVersao(versao){
   this.VERSAO = versao.value
 }

 excluirCodCat(){
  this.acessarVersao.excluirVersao();
  $("#modalExcluir").modal('hide');
 

}
Refresh(){
  this.rodar = "fa-spin"
  this.acessoAPI.CarregarVersaoLoja().subscribe(res =>{
    this.arrayVersao = res

    this.rowData = this.arrayVersao

    this.rodar = ""

  }, error =>{
  })

}


 enviarDados(){

    this.acessoAPI.EnviaDadosVersaoLoja(this.COD_LOJA, this.ID_SIS, this.VERSAO, this.QTDE_PDV,
       this.TIPO_INST,this.OBS_INST).subscribe( data =>{
        this.notificacao.success(
          'Solicitação enviada!',
          'Versão loja gravada com sucesso',
          {
            timeOut: 2000,
            showProgressBar: false,
            pauseOnHover: false,
            clickToClose: false,
            maxLength: 2
          }
        )
        $("#modalAdicionar").modal('hide');

      }, error =>{
        this.notificacao.error(
          'Solicitação enviada!',
          JSON.stringify(error._body),
          {
            timeOut: 2000,
            showProgressBar: false,
            pauseOnHover: false,
            clickToClose: false,
            maxLength: 2
          }
        )
       })

 }

}



// WEBPACK FOOTER //
// ./src/app/pages/administracao/versao/versao.component.ts